exports.components = {
  "component---src-pages-preview-tsx": () => import("./../../../src/pages/preview.tsx" /* webpackChunkName: "component---src-pages-preview-tsx" */),
  "component---src-templates-storyblok-entry-template-tsx": () => import("./../../../src/templates/storyblok-entry.template.tsx" /* webpackChunkName: "component---src-templates-storyblok-entry-template-tsx" */)
}

